<template>
  <div class="sign-orc-sign" v-if="detail.id">
    <div class="page-warp">
      <div class="top-info-box">
        <img src="@static/images/order/info-icon.png" class="" />
        <span
          >为了保障您的合法权益，需要对您进行身份认证，请投保人<strong>{{ detail.policyerName }}</strong
          >上传身份证照片</span
        >
      </div>
      <div class="form-box">
        <div class="form-title">投保人信息</div>
        <div class="form-row">
          <div class="label">姓名</div>
          <div class="text">{{ detail.policyerName }}</div>
        </div>
        <div class="form-row">
          <div class="label">身份证</div>
          <div class="text">{{ detail.policyerIdCard }}</div>
        </div>
      </div>
      <div class="form-box line">
        <div class="form-title">身份证图片</div>
        <div class="uplaod-list">
          <van-uploader
            v-model="fileList.holderIdCardNegative"
            :after-read="update"
            name="holderIdCardNegative"
            :multiple="false"
            accept="image/jpeg,image/png"
            :max-count="1"
            ref="uploader"
          >
            <img src="@static/images/order/issue/idcard-head.png" class="upload-img" />
            <div class="info">
              <span class="text1">人像面</span>
              <span class="text2">上传照片</span>
            </div>
          </van-uploader>
          <van-uploader
            v-model="fileList.holderIdCardPositive"
            :after-read="update"
            name="holderIdCardPositive"
            :multiple="false"
            accept="image/jpeg,image/png"
            :max-count="1"
            ref="uploader"
          >
            <img src="@static/images/order/issue/idcard-badge.png" class="upload-img" />
            <div class="info">
              <span class="text1">国徽面</span>
              <span class="text2">上传照片</span>
            </div>
          </van-uploader>
        </div>
      </div>
      <div class="form-box line">
        <div class="form-title">注意事项</div>
        <div class="text-box">
          <p>1. 请您将证件横向放平，手机横向拍摄</p>
          <p>2. 请您上传边框完整，图像清晰，光线均匀的照片</p>
        </div>
        <div class="ex-list">
          <div class="ex-item">
            <img src="@static/images/order/issue/ex-1.png" class="ex-img" />
            <div class="res-box">
              <img src="@static/images/order/issue/ok-icon.png" class="ok-icon" />
              <span>标准拍摄</span>
            </div>
          </div>
          <div class="ex-item">
            <img src="@static/images/order/issue/ex-2.png" class="ex-img" />
            <div class="res-box">
              <img src="@static/images/order/issue/error-icon.png" class="error-icon" />
              <span>边框缺失</span>
            </div>
          </div>
          <div class="ex-item">
            <img src="@static/images/order/issue/ex-3.png" class="ex-img" />
            <div class="res-box">
              <img src="@static/images/order/issue/error-icon.png" class="error-icon" />
              <span>照片模糊</span>
            </div>
          </div>
          <div class="ex-item">
            <img src="@static/images/order/issue/ex-4.png" class="ex-img" />
            <div class="res-box">
              <img src="@static/images/order/issue/error-icon.png" class="error-icon" />
              <span>闪光强烈</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="btn" @click="submit()">下一步</div>
    </div>
  </div>
</template>
<script>
//当前实例组件
export default {
  props: {
    detail: null
  },
  data() {
    return {
      fileList: {
        holderIdCardNegative: [],
        holderIdCardPositive: []
      },
      res: {}
    };
  },
  mounted() {},
  methods: {
    // 下一步
    submit() {
      if (this.fileList.holderIdCardNegative.length == 0) {
        this.$notice.msg('请上传身份证人像面');
      } else if (this.fileList.holderIdCardNegative[0].status == 'uploading') {
        this.$notice.msg('请等待身份证人像面上传完成');
      } else if (this.fileList.holderIdCardPositive.length == 0) {
        this.$notice.msg('请上传身份证国徽面');
      } else if (this.fileList.holderIdCardPositive[0].status == 'uploading') {
        this.$notice.msg('请等待身份证国徽面上传完成');
      } else {
        this.$emit('next');
      }
    },
    //获取加固签名
    getFirmSign() {
      let device;
      if (localStorage.getItem('device_no')) {
        device = localStorage.getItem('device_no');
      } else {
        let returnStr = '',
          charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 16; i++) {
          let index = Math.round(Math.random() * (charStr.length - 1));
          returnStr += charStr.substring(index, index + 1);
        }
        localStorage.setItem('device_no', returnStr);
        device = returnStr;
      }
      return this.$http({
        url: '/api/refund/ocrSign',
        type: 'POST',
        data: {
          'device': device
        }
      }).then(res => {
        return res.data;
      });
    },
    /**
     * 上传图片
     */
    async update(file, detail) {
      console.log(file, detail);
      const sign = await this.getFirmSign();
      console.log('sign', sign);
      const param = new FormData(); //创建form对象
      file.status = 'uploading';
      file.message = '上传中...';
      param.append('file', file.file);
      param.append('policyNo', this.$route.query.realPolicyNo);
      param.append('orderNo', this.$route.query.key);
      param.append('sign', sign);
      param.append(
        'params',
        JSON.stringify({
          element: detail.name,
          ocrFlag: 1
        })
      );
      this.$http({
        url: `/api/refund/${this.$route.query.plat}/ocr`,
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          file.status = "done";
          console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.fileList[detail.name] = [];
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './ocrSign.scss';
</style>
